export class TableDataSet {
  /**
   * @var {array}
   */
  data;

  /**
   * @var {?number}
   */
  total;

  constructor(data, total = null) {
    this.data = data;
    this.total = total;
  }
}
